module.exports = __webpack_public_path__ + "static/media/Logo.4de2e1fd.png";